export default __webpack_public_path__ + "static/light-house-thumb-257c2ae0bcbc764eecf853a84d0242a2.jpg";